import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import ControlPointDuplicate from '@mui/icons-material/ControlPointDuplicate';
import type { RightDrawerActionType } from './types';
import { RightDrawerAction } from './types';
import IconButton from '@mui/material/IconButton';
import { Colors } from 'styles';

export const RightDrawerActionIcon = ({
  type,
  onClick,
  lightweight = false,
  iconStyle = {},
  dataTestId = '',
  dataTestValue = '',
}: {
  type: RightDrawerActionType;
  onClick?: () => void;
  lightweight?: boolean;
  iconStyle?: {
    [key: string]: string | number;
  };
  dataTestId?: string;
  dataTestValue?: string;
}): React.ReactElement => {
  const style = {
    fontSize: 12,
    '&:focus svg': {
      opacity: 1,
    },
    ...iconStyle,
  } as const;

  const icon =
    type === RightDrawerAction.Edit ? (
      <EditIcon style={style} className="editIcon" />
    ) : (
      <ControlPointDuplicate style={style} className="cloneIcon" />
    );

  if (lightweight) return icon;

  let tooltipTitle = '';
  if (type === RightDrawerAction.Edit) {
    tooltipTitle = 'Edit';
  } else {
    tooltipTitle = 'Clone';
  }

  return (
    <IconButton
      data-testid={dataTestId}
      data-testvalue={dataTestValue}
      size="small"
      onMouseDown={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick?.();
      }}
      sx={{
        color: Colors.gray10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Tooltip title={tooltipTitle}>{icon}</Tooltip>
    </IconButton>
  );
};
